import { render, staticRenderFns } from "./CustomNoHeaderModal.vue?vue&type=template&id=6a959bee&"
import script from "./CustomNoHeaderModal.vue?vue&type=script&lang=js&"
export * from "./CustomNoHeaderModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomNoHeaderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports